module.exports = __webpack_public_path__ + "static/klspl2-98d1203743759e539153c1364592b359.png";